import React from 'react';
import styled from 'styled-components';
import RelativeDay from '../../components/Day/RelativeDay';
import ShowMore from './ShowMore';
import SlotSelectorStates from '../../components/SlotSelectorStates';

const DayShowMoreContainer = styled.div.withConfig({ componentId: 'sc-1cfyx1e-0' })`
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto 15px;
`;

const TodayContainer = styled.div.withConfig({ componentId: 'sc-1cfyx1e-1' })`
  margin-bottom: 20px;
`;

type Props = {
  selectedDate: any;
  location: any;
  modalState?: any;
  futureSlotData: any;
  handleSelectSlot: (...args: any[]) => any;
  nextDate: any;
  selectedSlots: any[];
  setHasOpenedTimeSelectorModal?: (...args: any[]) => any;
  shouldShowWalkInCopy?: boolean;
  isVisible?: boolean;
  handleClickShowMore?: (...args: any[]) => any;
  setAndHandleDate: (...args: any[]) => any;
  // Below are old booking flow props
  shouldSelectFirstSlotAsInitialValue: boolean;
  shouldSetSelectedSlotToFirstVisibleSlot: boolean;
  shouldShowNextAvailableAppointmentCta?: boolean;
};

const NoSlotsToday = (props: Props) => {
  const {
    location,
    futureSlotData,
    handleSelectSlot,
    nextDate,
    selectedSlots,
    shouldShowWalkInCopy,
    selectedDate,
    isVisible,
    handleClickShowMore,
    setAndHandleDate,
    //  Below are old booking flow props
    shouldSelectFirstSlotAsInitialValue,
    shouldSetSelectedSlotToFirstVisibleSlot,
    shouldShowNextAvailableAppointmentCta = false,
  } = props;

  if (!isVisible) return null;

  return (
    <TodayContainer>
      <DayShowMoreContainer>
        <RelativeDay selectedDate={selectedDate} timeZone={location.timeZone} />

        <ShowMore onClick={handleClickShowMore as any} shouldShowMore={false} />
      </DayShowMoreContainer>

      <SlotSelectorStates
        allowExpandInPlace={false}
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        location={location}
        nextDate={nextDate}
        selectedDate={selectedDate}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowNextAvailableAppointmentCta={shouldShowNextAvailableAppointmentCta}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />
    </TodayContainer>
  );
};

export default NoSlotsToday;
